<template>
    <img
        src="/images/logo-long.svg"
        alt="SportsDock logo"
        width="664"
        height="74"
    />
</template>
